import { paginationSplitApi as api } from './pagination.template.api';

export const addTagTypes = [
  'Companies',
  'Employee',
  'Group',
  'Task Template',
  'Task',
  'PublicAPI',
  'Admin',
  'Public API Employee',
  'Public API Group',
  'Public API Vacation',
  'Public API Universal Document',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      listCompanyUsers: build.query<
        ListCompanyUsersResponse,
        ListCompanyUsersArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/company/${queryArg.companyId}/users`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['Companies'],
      }),
      getCompanyCheckList: build.query<
        GetCompanyCheckListResponse,
        GetCompanyCheckListArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/company/${queryArg}/check-list`,
        }),
        providesTags: ['Companies'],
      }),
      getCompaniesCheckList: build.query<
        GetCompaniesCheckListResponse,
        GetCompaniesCheckListArg
      >({
        query: () => ({ url: `/api/internal/v1/company/check-list` }),
        providesTags: ['Companies'],
      }),
      doneCompanyCheckListItem: build.mutation<
        DoneCompanyCheckListItemResponse,
        DoneCompanyCheckListItemArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/company/${queryArg.companyId}/check-list/${queryArg.itemType}/done`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Companies'],
      }),
      listEmployees: build.query<ListEmployeesResponse, ListEmployeesArg>({
        query: (queryArg) => ({
          url: `/api/internal/v1/employee`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            ordering: queryArg.ordering,
            company__in: queryArg.companyIn,
            status__in: queryArg.statusIn,
            group__in: queryArg.groupIn,
            leader__in: queryArg.leaderIn,
            sign_type__in: queryArg.signTypeIn,
            ipn__in: queryArg.ipnIn,
            position__in: queryArg.positionIn,
            phone: queryArg.phone,
            search: queryArg.search,
          },
        }),
        providesTags: ['Employee'],
      }),
      listEmployeeAbsences: build.query<
        ListEmployeeAbsencesResponse,
        ListEmployeeAbsencesArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/employee/${queryArg.employeeId}/absences`,
          params: {
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['Employee'],
      }),
      employeeListAttachment: build.query<
        EmployeeListAttachmentResponse,
        EmployeeListAttachmentArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/employee/${queryArg.employeeId}/attachment`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            task_id__in: queryArg.taskIdIn,
            attachment_type__in: queryArg.attachmentTypeIn,
          },
        }),
        providesTags: ['Employee'],
      }),
      listEmployeeDocuments: build.query<
        ListEmployeeDocumentsResponse,
        ListEmployeeDocumentsArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/employee/${queryArg.employeeId}/documents`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            ordering: queryArg.ordering,
            document_type__in: queryArg.documentTypeIn,
          },
        }),
        providesTags: ['Employee'],
      }),
      listGroups: build.query<ListGroupsResponse, ListGroupsArg>({
        query: (queryArg) => ({
          url: `/api/internal/v1/group`,
          params: {
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company_id: queryArg.companyId,
            search: queryArg.search,
          },
        }),
        providesTags: ['Group'],
      }),
      listTaskTemplates: build.query<
        ListTaskTemplatesResponse,
        ListTaskTemplatesArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/task-template`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company__in: queryArg.companyIn,
            status__in: queryArg.statusIn,
            task_type__in: queryArg.taskTypeIn,
            task_type__not_in: queryArg.taskTypeNotIn,
            search: queryArg.search,
            is_onboarding: queryArg.isOnboarding,
          },
        }),
        providesTags: ['Task Template'],
      }),
      listTaskTemplatesByBatch: build.query<
        ListTaskTemplatesByBatchResponse,
        ListTaskTemplatesByBatchArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/task-template/batch/${queryArg.taskTemplateBatch}`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company__in: queryArg.companyIn,
            status__in: queryArg.statusIn,
            task_type__in: queryArg.taskTypeIn,
            task_type__not_in: queryArg.taskTypeNotIn,
            search: queryArg.search,
            is_onboarding: queryArg.isOnboarding,
          },
        }),
        providesTags: ['Task Template'],
      }),
      listTaskDocuments: build.query<
        ListTaskDocumentsResponse,
        ListTaskDocumentsArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/task/${queryArg}/document`,
        }),
        providesTags: ['Task'],
      }),
      listTasks: build.query<ListTasksResponse, ListTasksArg>({
        query: (queryArg) => ({
          url: `/api/internal/v1/task`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company__in: queryArg.companyIn,
            task_template__in: queryArg.taskTemplateIn,
            status__in: queryArg.statusIn,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            manager__in: queryArg.managerIn,
            search: queryArg.search,
            require_attention: queryArg.requireAttention,
          },
        }),
        providesTags: ['Task'],
      }),
      listCompanyPublicTokens: build.query<
        ListCompanyPublicTokensResponse,
        ListCompanyPublicTokensArg
      >({
        query: (queryArg) => ({
          url: `/api/internal/v1/public-api/company/${queryArg}/tokens`,
        }),
        providesTags: ['PublicAPI'],
      }),
      listCompanyAdmin: build.query<
        ListCompanyAdminResponse,
        ListCompanyAdminArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/v1/company`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            plan__in: queryArg.planIn,
          },
        }),
        providesTags: ['Admin'],
      }),
      publicListEmployees: build.query<
        PublicListEmployeesResponse,
        PublicListEmployeesArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/employee`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            ordering: queryArg.ordering,
            status__in: queryArg.statusIn,
            group__in: queryArg.groupIn,
            leader__in: queryArg.leaderIn,
            sign_type__in: queryArg.signTypeIn,
            position__in: queryArg.positionIn,
          },
        }),
        providesTags: ['Public API Employee'],
      }),
      publicListEmployeeAbsences: build.query<
        PublicListEmployeeAbsencesResponse,
        PublicListEmployeeAbsencesArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/employee/${queryArg.employeeId}/absences`,
          params: {
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['Public API Employee'],
      }),
      publicListGroups: build.query<
        PublicListGroupsResponse,
        PublicListGroupsArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/group`,
          params: {
            ordering: queryArg.ordering,
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ['Public API Group'],
      }),
      publicListVacationTemplates: build.query<
        PublicListVacationTemplatesResponse,
        PublicListVacationTemplatesArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/vacation/template`,
          params: {
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ['Public API Vacation'],
      }),
      publicListVacations: build.query<
        PublicListVacationsResponse,
        PublicListVacationsArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/vacation`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company__in: queryArg.companyIn,
            task_template__in: queryArg.taskTemplateIn,
            status__in: queryArg.statusIn,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            manager__in: queryArg.managerIn,
            search: queryArg.search,
            require_attention: queryArg.requireAttention,
          },
        }),
        providesTags: ['Public API Vacation'],
      }),
      publicListVacationDocuments: build.query<
        PublicListVacationDocumentsResponse,
        PublicListVacationDocumentsArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/vacation/${queryArg}/document`,
        }),
        providesTags: ['Public API Vacation'],
      }),
      publicListVacationDocumentSigners: build.query<
        PublicListVacationDocumentSignersResponse,
        PublicListVacationDocumentSignersArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/vacation/${queryArg.taskId}/document/${queryArg.documentId}/signer`,
        }),
        providesTags: ['Public API Vacation'],
      }),
      publicListUniversalDocuments: build.query<
        PublicListUniversalDocumentsResponse,
        PublicListUniversalDocumentsArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/universal-document`,
          params: {
            all: queryArg.all,
            id__in: queryArg.idIn,
            id__not_in: queryArg.idNotIn,
            page_num: queryArg.pageNum,
            page_size: queryArg.pageSize,
            company__in: queryArg.companyIn,
            task_template__in: queryArg.taskTemplateIn,
            status__in: queryArg.statusIn,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            manager__in: queryArg.managerIn,
            search: queryArg.search,
            require_attention: queryArg.requireAttention,
          },
        }),
        providesTags: ['Public API Universal Document'],
      }),
      publicListUniversalDocumentDocuments: build.query<
        PublicListUniversalDocumentDocumentsResponse,
        PublicListUniversalDocumentDocumentsArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/universal-document/${queryArg}/document`,
        }),
        providesTags: ['Public API Universal Document'],
      }),
      publicListUniversalDocumentDocumentSigners: build.query<
        PublicListUniversalDocumentDocumentSignersResponse,
        PublicListUniversalDocumentDocumentSignersArg
      >({
        query: (queryArg) => ({
          url: `/api/public/v1/universal-document/${queryArg.taskId}/document/${queryArg.documentId}/signer`,
        }),
        providesTags: ['Public API Universal Document'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as paginationApi };
export type ListCompanyUsersResponse =
  /** status 200 Successful Response */ ResponseModelPageCompanyUserListSerializer;
export type ListCompanyUsersArg = {
  companyId: string;
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  search?: string | null;
};
export type GetCompanyCheckListResponse =
  /** status 200 Successful Response */ ResponseModelCompanyCheckList;
export type GetCompanyCheckListArg = string;
export type GetCompaniesCheckListResponse =
  /** status 200 Successful Response */ ResponseModelUsersCompaniesCheckLists;
export type GetCompaniesCheckListArg = void;
export type DoneCompanyCheckListItemResponse =
  /** status 200 Successful Response */ ResponseModelCompanyCheckListItem;
export type DoneCompanyCheckListItemArg = {
  companyId: string;
  itemType: CompanyCheckListItemType;
};
export type ListEmployeesResponse =
  /** status 200 Successful Response */ ResponseModelPageEmployeeRetrieveSerializer;
export type ListEmployeesArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  ordering?:
    | (
        | 'first_name'
        | '-first_name'
        | 'last_name'
        | '-last_name'
        | 'middle_name'
        | '-middle_name'
      )[]
    | null;
  companyIn?: string[] | null;
  statusIn?: EmployeeStatus[] | null;
  groupIn?: string[] | null;
  leaderIn?: string[] | null;
  signTypeIn?: EmployeeSignType[] | null;
  ipnIn?: (string | string | string)[] | null;
  positionIn?: string[] | null;
  phone?: string | null;
  search?: string | null;
};
export type ListEmployeeAbsencesResponse =
  /** status 200 Successful Response */ ResponseModelPageFullWorkingPeriodAbsence;
export type ListEmployeeAbsencesArg = {
  employeeId: string;
  pageNum?: number;
  pageSize?: number;
};
export type EmployeeListAttachmentResponse =
  /** status 200 Successful Response */ ResponseModelPageFullTaskAttachment;
export type EmployeeListAttachmentArg = {
  employeeId: string;
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  taskIdIn?: string[] | null;
  attachmentTypeIn?: TaskAttachmentType[] | null;
};
export type ListEmployeeDocumentsResponse =
  /** status 200 Successful Response */ ResponseModelPageEmployeeDocumentRetrieveSerializer;
export type ListEmployeeDocumentsArg = {
  employeeId: string;
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  ordering?: ('date_created' | '-date_created')[] | null;
  documentTypeIn?: EmployeeDocumentType[] | null;
};
export type ListGroupsResponse =
  /** status 200 Successful Response */ ResponseModelPageGroupRetrieveSerializer;
export type ListGroupsArg = {
  pageNum?: number;
  pageSize?: number;
  companyId: string;
  search?: string | null;
};
export type ListTaskTemplatesResponse =
  /** status 200 Successful Response */ ResponseModelPageTaskTemplateListSerializer;
export type ListTaskTemplatesArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  companyIn?: string[] | null;
  statusIn?: TaskTemplateStatus[] | null;
  taskTypeIn?: TaskTemplateType[] | null;
  taskTypeNotIn?: TaskTemplateType[] | null;
  search?: string | null;
  isOnboarding?: boolean;
};
export type ListTaskTemplatesByBatchResponse =
  /** status 200 Successful Response */ ResponseModelPageTaskTemplateListSerializer;
export type ListTaskTemplatesByBatchArg = {
  taskTemplateBatch: TaskTemplateBatch;
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  companyIn?: string[] | null;
  statusIn?: TaskTemplateStatus[] | null;
  taskTypeIn?: TaskTemplateType[] | null;
  taskTypeNotIn?: TaskTemplateType[] | null;
  search?: string | null;
  isOnboarding?: boolean;
};
export type ListTaskDocumentsResponse =
  /** status 200 Successful Response */ ResponseModelPageTaskDocumentRetrieveSerializer;
export type ListTaskDocumentsArg = string;
export type ListTasksResponse =
  /** status 200 Successful Response */ ResponseModelPageTaskListSerializer;
export type ListTasksArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  companyIn?: string[] | null;
  taskTemplateIn?: string[] | null;
  statusIn?: TaskStatus[] | null;
  startDate?: string | null;
  endDate?: string | null;
  managerIn?: string[] | null;
  search?: string | null;
  requireAttention?: boolean | null;
};
export type ListCompanyPublicTokensResponse =
  /** status 200 Successful Response */ ResponseModelPublicTokenListSerializer;
export type ListCompanyPublicTokensArg = string;
export type ListCompanyAdminResponse =
  /** status 200 Successful Response */ ResponseModelPageInternalCompany;
export type ListCompanyAdminArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  search?: string | null;
  planIn?: CompanyPlanType[] | null;
};
export type PublicListEmployeesResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiEmployeeRetrieveSerializer;
export type PublicListEmployeesArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  ordering?: string[] | null;
  statusIn?: EmployeeStatus[] | null;
  groupIn?: string[] | null;
  leaderIn?: string[] | null;
  signTypeIn?: EmployeeSignType[] | null;
  positionIn?: string[] | null;
};
export type PublicListEmployeeAbsencesResponse =
  /** status 200 Successful Response */ ResponseModelPageFullWorkingPeriodAbsence;
export type PublicListEmployeeAbsencesArg = {
  employeeId: string;
  pageNum?: number;
  pageSize?: number;
};
export type PublicListGroupsResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiGroupRetrieveSerializer;
export type PublicListGroupsArg = {
  ordering?: string[] | null;
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  search?: string | null;
};
export type PublicListVacationTemplatesResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiRetrieveVacationTemplateSerializer;
export type PublicListVacationTemplatesArg = {
  pageNum?: number;
  pageSize?: number;
};
export type PublicListVacationsResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiRetrieveVacationSerializer;
export type PublicListVacationsArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  companyIn?: string[] | null;
  taskTemplateIn?: string[] | null;
  statusIn?: TaskStatus[] | null;
  startDate?: string | null;
  endDate?: string | null;
  managerIn?: string[] | null;
  search?: string | null;
  requireAttention?: boolean | null;
};
export type PublicListVacationDocumentsResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiListVacationDocumentSerializer;
export type PublicListVacationDocumentsArg = string;
export type PublicListVacationDocumentSignersResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiRetrieveDocumentSignerSerializer;
export type PublicListVacationDocumentSignersArg = {
  taskId: string;
  documentId: string;
};
export type PublicListUniversalDocumentsResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiRetrieveUniversalDocumentSerializer;
export type PublicListUniversalDocumentsArg = {
  all?: boolean;
  idIn?: string[] | null;
  idNotIn?: string[] | null;
  pageNum?: number;
  pageSize?: number;
  companyIn?: string[] | null;
  taskTemplateIn?: string[] | null;
  statusIn?: TaskStatus[] | null;
  startDate?: string | null;
  endDate?: string | null;
  managerIn?: string[] | null;
  search?: string | null;
  requireAttention?: boolean | null;
};
export type PublicListUniversalDocumentDocumentsResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiListUniversalDocumentDocumentSerializer;
export type PublicListUniversalDocumentDocumentsArg = string;
export type PublicListUniversalDocumentDocumentSignersResponse =
  /** status 200 Successful Response */ ResponseModelPagePublicApiRetrieveDocumentSignerSerializer;
export type PublicListUniversalDocumentDocumentSignersArg = {
  taskId: string;
  documentId: string;
};
export type ProfileImageFileKey = {
  /** Ключ файлу на S3 */
  orig_img: string;
  square_orig?: string | null;
  square_mid?: string | null;
  square_small?: string | null;
};
export type CompanyUserListSerializer = {
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  phone?: string | null;
  email: string;
  status: UserRoleActiveStatus;
  profile_image?: ProfileImageFileKey | null;
};
export type PageCompanyUserListSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: CompanyUserListSerializer[];
};
export type ResponseModelPageCompanyUserListSerializer = {
  detail: PageCompanyUserListSerializer;
};
export type UnauthorizedErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type CompanyAccessErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type ValidationErrorModel = {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: string | null;
  ctx?: {
    [key: string]: any;
  } | null;
};
export type ValidationErrorResponseModel = {
  error_code?: 'ValidationError';
  detail: ValidationErrorModel[];
  error_message?: string | null;
};
export type Company = {
  edrpou: string | string | string;
  name: string | null;
  color: string | null;
  leader_id: string | null;
  max_employees_count: number;
  id: string;
};
export type CompanyCheckListItem = {
  company_id: string;
  progress_status?: CompanyCheckListItemProgressStatus;
  item_type: CompanyCheckListItemType;
  id: string;
};
export type CompanyCheckList = {
  company: Company;
  items: CompanyCheckListItem[];
};
export type ResponseModelCompanyCheckList = {
  detail: CompanyCheckList;
};
export type User = {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  status: UserStatus;
  middle_name?: string | null;
  vchasno_id?: string | null;
  photo_media_file_id?: string | null;
  locale?: Language;
  profile_image?: ProfileImageFileKey | null;
};
export type UserRole = {
  can_invite_coworkers: boolean;
  can_generate_api_keys: boolean;
  can_change_company_info: boolean;
  can_view_company_logs: boolean;
  id: string;
  user: User;
  company: Company;
  role: UserCompanyRole | null;
  active_status: UserRoleActiveStatus;
  can_change_activity_status: boolean;
};
export type CompanyCheckListSerializer = {
  user_role: UserRole;
  items: CompanyCheckListItem[];
};
export type UsersCompaniesCheckLists = {
  check_lists: CompanyCheckListSerializer[];
};
export type ResponseModelUsersCompaniesCheckLists = {
  detail: UsersCompaniesCheckLists;
};
export type ResponseModelCompanyCheckListItem = {
  detail: CompanyCheckListItem;
};
export type CompanyRetrieveSerializer = {
  id: string;
  name: string | null;
};
export type LeaderRetrieveSerializer = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  middle_name?: string | null;
  status: EmployeeStatus;
  profile_photo?: ProfileImageFileKey | null;
};
export type GroupRetrieveSerializer = {
  id: string;
  name: string;
};
export type EmployeeOnboardingAttempt = {
  company_id: string;
  diia_offer_id?: string | null;
  employee_id?: string | null;
  user_id: string;
  phone: string;
  status?: EmployeeOnboardingAttemptStatus;
  id: string;
};
export type EmployeeRetrieveSerializer = {
  ipn?: string | string | string | null;
  email?: string | null;
  work_email?: string | null;
  phone?: string | null;
  position?: string | null;
  date_joined?: string | null;
  date_of_birth?: string | null;
  company_number?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  company: CompanyRetrieveSerializer;
  id: string;
  status: EmployeeStatus;
  leader?: LeaderRetrieveSerializer | null;
  managerial_leader?: LeaderRetrieveSerializer | null;
  group?: GroupRetrieveSerializer | null;
  vacation_days: number | null;
  profile_photo: ProfileImageFileKey | null;
  edo_status: EmployeeEdoStatus;
  sign_type: EmployeeSignType;
  onboarding_attempt?: EmployeeOnboardingAttempt | null;
};
export type PageEmployeeRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: EmployeeRetrieveSerializer[];
};
export type ResponseModelPageEmployeeRetrieveSerializer = {
  detail: PageEmployeeRetrieveSerializer;
};
export type MonthlyChange = {
  /** Дата в форматі 'YYYY-MM-DD' */
  date: string;
  prev_allowed_days: string | null;
  new_allowed_days?: string | null;
};
export type TaskTemplate = {
  id: string;
  created_by_id: string;
  version_identifier: string;
  version: number;
  name: string;
  mobile_name: string | null;
  document_name: string | null;
  period_type: TaskPeriodType;
  status: TaskTemplateStatus;
  type: TaskTemplateType;
  company_id: string;
  default_manager_id: string | null;
};
export type AbsenceUsage = {
  used_days: string;
  task_id: string | null;
  absence_id: string;
  id: string;
};
export type FullAbsence = {
  period_id: string;
  absence_type: AbsenceType;
  allowed_days: string | null;
  left_days: string | null;
  monthly_changes?: MonthlyChange[] | null;
  id: string;
  task_template: TaskTemplate | null;
  used?: string | null;
  usages: AbsenceUsage[];
};
export type FullWorkingPeriodAbsence = {
  id: string;
  employee_id: string;
  /** Дата в форматі 'YYYY-MM-DD' */
  date_start: string;
  /** Дата в форматі 'YYYY-MM-DD' */
  date_end: string;
  absences: FullAbsence[];
};
export type PageFullWorkingPeriodAbsence = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: FullWorkingPeriodAbsence[];
};
export type ResponseModelPageFullWorkingPeriodAbsence = {
  detail: PageFullWorkingPeriodAbsence;
};
export type EmployeeReadPermissionErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type MediaFile = {
  /** Ключ файлу на S3 */
  file_key: string;
  type: MediaFileType;
  uploader_id?: string | null;
  uploader_employee_id?: string | null;
  antivirus_check_status?: AntivirusCheckStatus;
  id: string;
};
export type FullTaskAttachment = {
  id: string;
  employee_id: string;
  media_file_id: string;
  attachment_type?: TaskAttachmentType | null;
  media_file: MediaFile;
};
export type PageFullTaskAttachment = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: FullTaskAttachment[];
};
export type ResponseModelPageFullTaskAttachment = {
  detail: PageFullTaskAttachment;
};
export type EmployeeDocumentRetrieveSerializer = {
  id: string;
  employee_id: string;
  document_type: EmployeeDocumentType;
  media_file_id: string;
  /** Дата з часом у форматі 'YYYY-MM-DDTHH:MM:SS' */
  date_created: string;
  media_file_key: string;
};
export type PageEmployeeDocumentRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: EmployeeDocumentRetrieveSerializer[];
};
export type ResponseModelPageEmployeeDocumentRetrieveSerializer = {
  detail: PageEmployeeDocumentRetrieveSerializer;
};
export type NotFoundErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type PageGroupRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: GroupRetrieveSerializer[];
};
export type ResponseModelPageGroupRetrieveSerializer = {
  detail: PageGroupRetrieveSerializer;
};
export type UserNameInformation = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  middle_name?: string | null;
};
export type MinimalCompany = {
  id: string;
  name: string;
  color?: string | null;
};
export type TaskTemplateListSerializer = {
  version_identifier: string;
  version: number;
  name: string;
  status: TaskTemplateStatus;
  type: TaskTemplateType;
  period_type: TaskPeriodType;
  created_by: UserNameInformation | null;
  company: MinimalCompany;
  default_manager: UserNameInformation | null;
  date_created: string;
  date_updated: string;
};
export type PageTaskTemplateListSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: TaskTemplateListSerializer[];
};
export type ResponseModelPageTaskTemplateListSerializer = {
  detail: PageTaskTemplateListSerializer;
};
export type SendDocumentPeriodDates = {
  start_date: string;
  end_date: string;
};
export type SendDocumentPeriod = {
  dates: SendDocumentPeriodDates[];
};
export type ExtendedFileDocumentInfoSerializer = {
  name?: string | null;
  document_number?: string | null;
  category?: HrsDocumentCategory | null;
  order_number?: string | null;
  periods?: SendDocumentPeriod | null;
  /** Чи працівник отримує матеріальну допомогу під час відпустки. */
  financial_assistance?: boolean;
};
export type TaskDocumentRetrieveSerializer = {
  id: string | null;
  task_id: string;
  task_route_id: string | null;
  document_type: TaskDocumentType | null;
  document_state: TaskRetrieveDocumentState;
  document_info: ExtendedFileDocumentInfoSerializer | null;
  name: string;
};
export type PageTaskDocumentRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: TaskDocumentRetrieveSerializer[];
};
export type ResponseModelPageTaskDocumentRetrieveSerializer = {
  detail: PageTaskDocumentRetrieveSerializer;
};
export type TaskAccessErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type MinimalEmployeeWithAbsences = {
  id: string;
  email: string | null;
  first_name: string;
  last_name: string;
  middle_name: string;
  position: string | null;
  vacation_days: number | null;
  profile_photo: ProfileImageFileKey | null;
};
export type MinimalTaskTemplateInfo = {
  version_identifier: string;
  version: number;
  name: string;
  mobile_name: string | null;
  document_name: string | null;
  status: TaskTemplateStatus;
  type: TaskTemplateType;
  period_type: TaskPeriodType;
};
export type PositionedUserNameInformation = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  middle_name?: string | null;
  position?: string | null;
  profile_photo?: ProfileImageFileKey | null;
};
export type UserNameInformationWithPhoto = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  middle_name?: string | null;
  profile_photo: ProfileImageFileKey | null;
};
export type TaskListSerializer = {
  id: string;
  status: TaskStatus;
  activity_status: TaskActivityStatus;
  initiator: MinimalEmployeeWithAbsences;
  task_template: MinimalTaskTemplateInfo;
  start_date: string | null;
  end_date: string | null;
  company: MinimalCompany;
  leader: PositionedUserNameInformation | null;
  manager: UserNameInformationWithPhoto | null;
  require_attention: boolean;
  description: string | null;
  cancellation_reason: string | null;
  require_attachments: boolean;
  documents_required_number: number;
  documents_sent_number: number;
};
export type PageTaskListSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: TaskListSerializer[];
};
export type ResponseModelPageTaskListSerializer = {
  detail: PageTaskListSerializer;
};
export type PublicTokenRetrieveSerializer = {
  id: string;
  company_id: string;
  active_status: PublicTokenActiveStatus;
  date_created: string;
};
export type PublicTokenListSerializer = {
  public_tokens: PublicTokenRetrieveSerializer[];
};
export type ResponseModelPublicTokenListSerializer = {
  detail: PublicTokenListSerializer;
};
export type Name = {
  full_name: string | null;
  short_name: string | null;
};
export type NameInEnglish = {
  full_name: string | null;
  short_name: string | null;
};
export type Address = {
  zip: string | null;
  country: string | null;
  region: string | null;
  district: string | null;
  city: string | null;
  city_type: string | null;
  street: string | null;
  street_type: string | null;
  building: string | null;
  sub_building: string | null;
  sub_building_type: string | null;
  apartment: string | null;
  apartment_type: string | null;
  atu: string | null;
  atu_code: string | null;
};
export type Signer = {
  name: string | null;
  role: string | null;
  description: string | null;
  appoint_date: string | string | null;
  raw: string | null;
};
export type LegalPersonRegisterData = {
  name: Name | string;
  name_in_english?: NameInEnglish | null;
  address?: string | null;
  address_parts?: Address | null;
  signers?: Signer[] | null;
};
export type InternalCompany = {
  edrpou: string | string | string;
  name: string | null;
  color: string | null;
  leader_id: string | null;
  max_employees_count: number;
  legal_info?: LegalPersonRegisterData | null;
  plan?: CompanyPlanType;
  id: string;
};
export type PageInternalCompany = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: InternalCompany[];
};
export type ResponseModelPageInternalCompany = {
  detail: PageInternalCompany;
};
export type AdminAccessErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type PublicApiEmployeeRetrieveSerializer = {
  id: string;
  /** Прізвище. Повинно починатися з великої літери. */
  last_name: string;
  first_name?: string | null;
  middle_name?: string | null;
  ipn?: string | string | string | null;
  email?: string | null;
  work_email?: string | null;
  phone?: string | null;
  position?: string | null;
  date_joined?: string | null;
  date_of_birth?: string | null;
  company_number?: string | null;
  company_id: string;
  status: EmployeeStatus;
  sign_type: EmployeeSignType;
  leader_id: string | null;
  managerial_leader_id: string | null;
  group_id: string | null;
};
export type PagePublicApiEmployeeRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiEmployeeRetrieveSerializer[];
};
export type ResponseModelPagePublicApiEmployeeRetrieveSerializer = {
  detail: PagePublicApiEmployeeRetrieveSerializer;
};
export type PublicApiGroupRetrieveSerializer = {
  id: string;
  name: string;
  leader_id?: string | null;
};
export type PagePublicApiGroupRetrieveSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiGroupRetrieveSerializer[];
};
export type ResponseModelPagePublicApiGroupRetrieveSerializer = {
  detail: PagePublicApiGroupRetrieveSerializer;
};
export type PublicApiRetrieveVacationTemplateSerializer = {
  version_identifier: string;
  type: TaskTemplateType;
  name: string;
};
export type PagePublicApiRetrieveVacationTemplateSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiRetrieveVacationTemplateSerializer[];
};
export type ResponseModelPagePublicApiRetrieveVacationTemplateSerializer = {
  detail: PagePublicApiRetrieveVacationTemplateSerializer;
};
export type PublicApiCompanyAccessErrorResponseModel = {
  error_code: string;
  detail: string;
  error_message?: string | null;
};
export type PublicApiRetrieveVacationSerializer = {
  id: string;
  /** ID співробітника, що ініціює запит. У випадку відпустки, це співробітник, що йде у відпустку. */
  initiator_id: string;
  template_version_identifier: string;
  status: TaskStatus;
  date_start: string | null;
  date_end: string | null;
  description: string | null;
  cancellation_reason: string | null;
};
export type PagePublicApiRetrieveVacationSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiRetrieveVacationSerializer[];
};
export type ResponseModelPagePublicApiRetrieveVacationSerializer = {
  detail: PagePublicApiRetrieveVacationSerializer;
};
export type PublicApiListVacationDocumentSerializer = {
  id: string;
  name: string;
  type: PublicDocumentType;
  status: TaskRouteStatus;
};
export type PagePublicApiListVacationDocumentSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiListVacationDocumentSerializer[];
};
export type ResponseModelPagePublicApiListVacationDocumentSerializer = {
  detail: PagePublicApiListVacationDocumentSerializer;
};
export type PublicApiRetrieveDocumentSignerSerializer = {
  executor_id: string;
  status: TaskRouteActionStatus;
};
export type PagePublicApiRetrieveDocumentSignerSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiRetrieveDocumentSignerSerializer[];
};
export type ResponseModelPagePublicApiRetrieveDocumentSignerSerializer = {
  detail: PagePublicApiRetrieveDocumentSignerSerializer;
};
export type PublicApiRetrieveUniversalDocumentSerializer = {
  id: string;
  /** ID співробітника, що ініціює запит. У випадку відпустки, це співробітник, що йде у відпустку. */
  initiator_id: string;
  status: TaskStatus;
  description: string | null;
  cancellation_reason: string | null;
};
export type PagePublicApiRetrieveUniversalDocumentSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiRetrieveUniversalDocumentSerializer[];
};
export type ResponseModelPagePublicApiRetrieveUniversalDocumentSerializer = {
  detail: PagePublicApiRetrieveUniversalDocumentSerializer;
};
export type PublicApiListUniversalDocumentDocumentSerializer = {
  id: string;
  name: string;
  status: TaskRouteStatus;
  document_info: ExtendedFileDocumentInfoSerializer | null;
};
export type PagePublicApiListUniversalDocumentDocumentSerializer = {
  page_num: number;
  page_size: number;
  has_prev: boolean;
  has_next: boolean;
  total_items: number | null;
  total_pages: number | null;
  items: PublicApiListUniversalDocumentDocumentSerializer[];
};
export type ResponseModelPagePublicApiListUniversalDocumentDocumentSerializer =
  {
    detail: PagePublicApiListUniversalDocumentDocumentSerializer;
  };
export enum UserRoleActiveStatus {
  Active = 'active',
  Inactive = 'inactive',
  Deleted = 'deleted',
}
export enum CompanyCheckListItemProgressStatus {
  Created = 'created',
  Done = 'done',
}
export enum CompanyCheckListItemType {
  AddEmployees = 'add_employees',
  AddEmployeesVocationsDays = 'add_employees_vocations_days',
  SetUpTasks = 'set_up_tasks',
}
export enum UserStatus {
  Pending = 'pending',
  Active = 'active',
  Deleted = 'deleted',
}
export enum Language {
  Uk = 'uk',
  En = 'en',
}
export enum UserCompanyRole {
  Admin = 'admin',
  Manager = 'manager',
  Employee = 'employee',
}
export enum EmployeeStatus {
  Candidate = 'candidate',
  Draft = 'draft',
  Working = 'working',
  Fired = 'fired',
  Archived = 'archived',
}
export enum EmployeeEdoStatus {
  NotExist = 'not_exist',
  Inactive = 'inactive',
  Active = 'active',
  Invited = 'invited',
  HasApp = 'has_app',
}
export enum EmployeeSignType {
  Personal = 'personal',
  Corporate = 'corporate',
}
export enum EmployeeOnboardingAttemptStatus {
  New = 'new',
  InProgress = 'in_progress',
  Completed = 'completed',
  Canceled = 'canceled',
}
export enum AbsenceType {
  Annual = 'annual',
  AnnualHazardous = 'annual_hazardous',
  AnnualSpecialWork = 'annual_special_work',
  SocialMaternityLeave = 'social_maternity_leave',
  SocialChildCare = 'social_child_care',
  SocialParental = 'social_parental',
  SocialChildBirth = 'social_child_birth',
  SocialAdoption = 'social_adoption',
  StudyEducational = 'study_educational',
  VacationSocialPco = 'vacation_social_pco',
  StudyCreative = 'study_creative',
  StudyAthletic = 'study_athletic',
  Unpaid = 'unpaid',
  UnpaidAgreed = 'unpaid_agreed',
  UnpaidMartialLaw = 'unpaid_martial_law',
  VacationAnnualOnboarding = 'vacation_annual_onboarding',
  VacationUnpaidOnboarding = 'vacation_unpaid_onboarding',
}
export enum TaskPeriodType {
  WorkingYear = 'working_year',
  CalendarYear = 'calendar_year',
}
export enum TaskTemplateStatus {
  Active = 'active',
  Inactive = 'inactive',
  Superseded = 'superseded',
  Archived = 'archived',
}
export enum TaskTemplateType {
  Vacation = 'vacation',
  VacationAnnual = 'vacation_annual',
  VacationAnnualHazardous = 'vacation_annual_hazardous',
  VacationAnnualSpecialWork = 'vacation_annual_special_work',
  VacationSocialMaternityLeave = 'vacation_social_maternity_leave',
  VacationSocialChildCare = 'vacation_social_child_care',
  VacationSocialParental = 'vacation_social_parental',
  VacationSocialChildBirth = 'vacation_social_child_birth',
  VacationSocialAdoption = 'vacation_social_adoption',
  VacationSocialPco = 'vacation_social_pco',
  VacationStudyEducational = 'vacation_study_educational',
  VacationStudyCreative = 'vacation_study_creative',
  VacationStudyAthletic = 'vacation_study_athletic',
  VacationUnpaid = 'vacation_unpaid',
  VacationUnpaidAgreed = 'vacation_unpaid_agreed',
  VacationUnpaidMartialLaw = 'vacation_unpaid_martial_law',
  VacationAnnualOnboarding = 'vacation_annual_onboarding',
  VacationUnpaidOnboarding = 'vacation_unpaid_onboarding',
  UniversalDocument = 'universal_document',
}
export enum TaskAttachmentType {
  BirthCertificate = 'birth_certificate',
  DisabilityCertificate = 'disability_certificate',
  SingleParentProof = 'single_parent_proof',
  AdoptionCourtDecision = 'adoption_court_decision',
  CohabitationProof = 'cohabitation_proof',
  MedicalConclusion = 'medical_conclusion',
  CombatParticipantId = 'combat_participant_id',
  EducationCallNotice = 'education_call_notice',
}
export enum MediaFileType {
  UserProfileImage = 'user_profile_image',
  EmployeeProfileImage = 'employee_profile_image',
  FileImport = 'file_import',
  TaskAttachment = 'task_attachment',
  DiiaMultisharingArchive = 'diia_multisharing_archive',
  DiiaDocument = 'diia_document',
}
export enum AntivirusCheckStatus {
  Checking = 'checking',
  Infected = 'infected',
  Clean = 'clean',
  Skip = 'skip',
}
export enum EmployeeDocumentType {
  InternalPassport = 'internal-passport',
  ForeignPassport = 'foreign-passport',
  TaxpayerCard = 'taxpayer-card',
  ReferenceInternallyDisplacedPerson = 'reference-internally-displaced-person',
  DriverLicense = 'driver-license',
  VehicleLicense = 'vehicle-license',
  UserBirthRecord = 'user-birth-record',
  BirthCertificate = 'birth-certificate',
  StudentIdCard = 'student-id-card',
  EducationDocument = 'education-document',
  PensionCard = 'pension-card',
  VeteranCertificate = 'veteran-certificate',
  ResidencePermitTemporary = 'residence-permit-temporary',
  ResidencePermitPermanent = 'residence-permit-permanent',
  MarriageActRecord = 'marriage-act-record',
  DivorceActRecord = 'divorce-act-record',
  NameChangeActRecord = 'name-change-act-record',
  IncomeReport = 'income-report',
}
export enum TaskTemplateBatch {
  Vacation = 'vacation',
  Documents = 'documents',
  VacationOnboarding = 'vacation_onboarding',
}
export enum TaskDocumentType {
  Request = 'request',
  Application = 'application',
  Order = 'order',
  Universal = 'universal',
}
export enum TaskRetrieveDocumentState {
  Generated = 'generated',
  Preview = 'preview',
}
export enum HrsDocumentCategory {
  Act = 'act',
  Contract = 'contract',
  Application = 'application',
  Appendix = 'appendix',
  Another = 'another',
  Order = 'order',
  Report = 'report',
  Letter = 'letter',
}
export enum TaskStatus {
  New = 'new',
  InProgress = 'in_progress',
  Completed = 'completed',
  Canceled = 'canceled',
}
export enum TaskActivityStatus {
  Active = 'active',
  Archived = 'archived',
}
export enum PublicTokenActiveStatus {
  Active = 'active',
  Inactive = 'inactive',
}
export enum CompanyPlanType {
  Free = 'free',
  Paid = 'paid',
}
export enum PublicDocumentType {
  Signing = 'signing',
  Approval = 'approval',
}
export enum TaskRouteStatus {
  New = 'new',
  InProgress = 'in_progress',
  Completed = 'completed',
  Canceled = 'canceled',
}
export enum TaskRouteActionStatus {
  New = 'new',
  Completed = 'completed',
  Declined = 'declined',
}
export const {
  useListCompanyUsersQuery,
  useGetCompanyCheckListQuery,
  useGetCompaniesCheckListQuery,
  useDoneCompanyCheckListItemMutation,
  useListEmployeesQuery,
  useListEmployeeAbsencesQuery,
  useEmployeeListAttachmentQuery,
  useListEmployeeDocumentsQuery,
  useListGroupsQuery,
  useListTaskTemplatesQuery,
  useListTaskTemplatesByBatchQuery,
  useListTaskDocumentsQuery,
  useListTasksQuery,
  useListCompanyPublicTokensQuery,
  useListCompanyAdminQuery,
  usePublicListEmployeesQuery,
  usePublicListEmployeeAbsencesQuery,
  usePublicListGroupsQuery,
  usePublicListVacationTemplatesQuery,
  usePublicListVacationsQuery,
  usePublicListVacationDocumentsQuery,
  usePublicListVacationDocumentSignersQuery,
  usePublicListUniversalDocumentsQuery,
  usePublicListUniversalDocumentDocumentsQuery,
  usePublicListUniversalDocumentDocumentSignersQuery,
} = injectedRtkApi;
